import { Box, Flex, Link, Text } from '@bigcommerce/big-design';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  
  return (
    <Box borderBottom="box" padding="medium">
      <Flex justifyContent="space-between" alignItems="center">
        <Text 
          bold 
          style={{ fontSize: '20px', cursor: 'pointer' }}
          onClick={() => navigate('/fees')}
        >
          Checkout Fees
        </Text>
        <Flex>
          <Link href="https://checkout.prangano.com/support" target="_blank" variant="tertiary">Support</Link>
          <Link href="/settings" variant="tertiary" marginLeft="medium">Settings</Link>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Header;
